import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/password';

@Component({
  templateUrl: './password.component.html'
})
export class PasswordComponent implements OnInit {

  	code = Code;
	headers: any[];
	parameters: any[];
	styleHeader: any[];
	styleValue: any[];
	
    constructor() {
        this.headers = [
	        {name : "名字"},
	        {name : "类型"},
	        {name : "默认"},
	        {name : "描述"}
	    ];
	    this.parameters = [
	        {name: "promptLabel",type: "array",default: "请输入密码",des: "文本提示密码输入。"},
	        {name: "weakLabel",type: "string",default: "Weak",des: "弱密码的文本。"},
	        {name: "mediumLabel",type: "string",default: "Medium",des: "中度密码的文本。"},
	        {name: "strongLabel",type: "boolean",default: "true",des: "强密码的文本。"},
	        {name: "feedback",type: "string",default: "null",des: "是否显示强度指标。"}
	    ];

	    this.styleHeader = [
	    	{name : "名字"},
	        {name : "元素"}
	    ];

	    this.styleValue = [
	    	{name : "ui-password-panel",el : "密码面板容器。"},
	    	{name : "ui-password-meter",el : "密码强度表元素。"},
	    	{name : "ui-password-info",el : "显示强度的文本。"}
	    ];
    }

    ngOnInit() {}

}



// WEBPACK FOOTER //
// ./src/app/view/password/password.component.ts